import React from 'react';
import '../styles/theme.css';
import '../styles/Contact.css';
import PortfolioTopNav from '../components/PortfolioTopNav';
import Footer from '../components/Footer';
import ContactCopyRecovery from '../components/ContactCopyRecovery';
import ContactPanelStage from '../components/ContactPanelStage';
/* IMPORTS */

function ContactPage() {
  return (
    <div className="co-root">
      <div className="co-layout-1">
        <div id="contacttopnav" className="co-slot-contacttopnav">
          <PortfolioTopNav activePage={"Contact"} />
        </div>
        <div className="co-layout-2">
          <div id="contactpanelstage" className="co-slot-contactpanelstage">
            <ContactPanelStage />
          </div>
          <div id="contactcopyrecovery" className="co-slot-contactcopyrecovery">
            <ContactCopyRecovery />
          </div>
        </div>
        <div className="co-layout-3">
          <div id="contactfooterband" className="co-slot-contactfooterband">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;